// useQuery.js
import { useLocation } from "react-router-dom"

// Resolves query or returns null
const useQuery = () => {
	return new URLSearchParams(useLocation().search);
}

export default useQuery